/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { BigNumberDependencies } from './dependenciesBigNumberClass.generated';
import { UnitDependencies } from './dependenciesUnitClass.generated';
import { createFaraday } from '../../factoriesAny.js';
export var faradayDependencies = {
  BigNumberDependencies: BigNumberDependencies,
  UnitDependencies: UnitDependencies,
  createFaraday: createFaraday
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesFaraday.generated.js
// module id = 1407
// module chunks = 0